<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'SETTINGS.TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row size="1200">
      <ion-col size="1200">
        <div *ngIf="loading">
          <ion-spinner></ion-spinner>
        </div>
          <div class="loaded-div" *ngIf="!loading && user; else notLoggedIn">
            <h2 *ngIf="user.displayName">{{ 'SETTINGS.WELCOME' | translate:{name: user.displayName} }}</h2>
            <h2 *ngIf="freshUser && !user.completedTour">{{ 'SETTINGS.FRESH_USER' | translate }}</h2>
            <p *ngIf="user.email">{{ 'SETTINGS.EMAIL' | translate:{email: user.email} }}</p>

            <!-- Username -->
            <ion-item>
              <ion-input
                label="Username"
                label-placement="stacked"
                [(ngModel)]="usernameInput"
                placeholder="Enter a username"
                maxlength="30">
              </ion-input>
            </ion-item>
            <ion-text *ngIf="usernameError" color="danger" class="field-message">{{ usernameError }}</ion-text>
            <ion-text *ngIf="usernameSuccess" color="success" class="field-message">Username saved!</ion-text>
            <ion-button
              [disabled]="usernameSaving || usernameInput.trim() === (user.displayName || '') || usernameInput.trim().length < 2"
              (click)="saveUsername()"
              color="primary"
              size="small">
              <ion-spinner *ngIf="usernameSaving" name="crescent" slot="start"></ion-spinner>
              Save Username
            </ion-button>

            <ion-item>
              <ion-label>{{ 'SETTINGS.NATIVE_LANGUAGE' | translate }}</ion-label>
              <ion-select [(ngModel)]="user.nativeLanguage" (ionChange)="onNativeLanguageChange(); onFieldChange()" interface="alert">
                <ion-select-option *ngFor="let lang of nativeLanguages" [value]="lang.code">
                  {{ lang.name }}
                </ion-select-option>
              </ion-select>
            </ion-item>
            <ion-item>
              <ion-label>{{ 'SETTINGS.TARGET_LANGUAGE' | translate }}</ion-label>
              <ion-select [(ngModel)]="user.targetLanguage" (ionChange)="onFieldChange()" interface="alert">
                <!-- Default placeholder option -->
                <ion-select-option value="" disabled selected>
                  {{ 'SETTINGS.SELECT_TARGET_LANGUAGE' | translate }}
                </ion-select-option>
                <ion-select-option *ngFor="let lang of targetLanguages" [value]="lang.code">
                  {{ lang.name }}
                </ion-select-option>
              </ion-select>
            </ion-item>
            <ion-item *ngIf="user.targetLanguage && user.targetLanguage !== ''">
              <ion-label>{{ 'SETTINGS.LANG_LEVEL' | translate }}</ion-label>
              <ion-select [(ngModel)]="user.level[user.targetLanguage]" (ionChange)="onFieldChange()" interface="alert">
                <ion-select-option value="" disabled selected>
                  {{ 'SETTINGS.SELECT_PROF_LEVEL' | translate }}
                </ion-select-option>
                <ion-select-option *ngFor="let level of fluencyLevels" [value]="level.value">
                  {{ level.label | translate }}
                </ion-select-option>
              </ion-select>
            </ion-item>
            <ion-button 
              *ngIf="user.nativeLanguage && user.targetLanguage && user.level[user.targetLanguage]" 
              [disabled]="!changesMade" 
              (click)="applyChanges()" 
              [color]="!changesMade ? 'medium' : 'success'">
              <ion-icon slot="start" name="checkmark"></ion-icon>
              {{ 'SETTINGS.APPLY' | translate }}
            </ion-button>
            <!--Sign out-->
            <ion-button color="danger" (click)="signOut()">
              <ion-icon slot="start" name="log-out"></ion-icon>
              {{ 'SETTINGS.SIGN_OUT' | translate }}
            </ion-button>
            <!-- Reading Settings -->
            <ion-button color="tertiary" (click)="goToReadingSettings()">
              <ion-icon slot="start" name="book"></ion-icon>
              {{ 'SETTINGS.READING_SETTINGS' | translate }}
            </ion-button>
            
            <!-- Delete Account -->
            <ion-button color="danger" fill="outline" (click)="deleteAccount()">
              <ion-icon slot="start" name="trash"></ion-icon>
              {{ 'SETTINGS.DELETE_ACCOUNT' | translate }}
            </ion-button>
            
            <!--<ion-text id="support-text" class="support-text">
              <a [href]="getPrivacyUrl()" class="support-link">{{ 'SETTINGS.NEED_HELP' | translate }}</a>
            </ion-text>-->
            <ion-text *ngIf="errorMessage" class="error-message">
              {{ errorMessage }}
            </ion-text>
          </div>
          <ng-template #notLoggedIn>
            <h2>{{ 'SETTINGS.NOT_LOGGED_IN' | translate }}</h2>
            <ion-button color="primary" (click)="goToLogin()">
              <ion-icon slot="start" name="log-in"></ion-icon>
              {{ 'SETTINGS.GO_TO_LOGIN' | translate }}
            </ion-button>
          </ng-template>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>